<template>
  <div>
    <a :ref="refName" id="supportLinkForTableAnalysisContainer" :class="{'d-none': !asLink}" :href="hrefMailtoLink">
      {{linkText}}
    </a>
    <span v-on:click="$refs[refName].click()">
      <slot></slot>
    </span>
  </div>
</template>
<script>

export default {
  name: "MailtoLink",
  props: ["asLink", "linkText", "emailsTo", "predefinedEmailContent", "emailContentObjects"],
  data() {
    return {
    }
  },
  mounted() {},
  computed: {
    refName: function() {
      if (this.predefinedEmailContent === undefined) {
        return 'support-mailto-link-ref';
      } else if (this.predefinedEmailContent === 'GET_A_DEMO') {
        return 'welcome-demo-mailto-link-ref';
      } else if (this.predefinedEmailContent === 'GET_API_ACCESS') {
        return 'welcome-apî-mailto-link-ref';
      } else if (this.predefinedEmailContent === 'GET_UI_ACCESS') {
        return 'welcome-ui-mailto-link-ref';
      }
      return 'support-mailto-link-ref';
    },
    emailContent: function() {
      const preprocessingResultContent = (this.emailContentObjects && this.emailContentObjects.preprocessingResult) ? JSON.stringify(this.emailContentObjects.preprocessingResult) : '<undefined>';
      const annotationContent = (this.emailContentObjects && this.emailContentObjects.annotationContent) ? JSON.stringify(this.emailContentObjects.annotationContent) : '<undefined>';
      const DEFAULT_EMAIL_CONTENT = `${this.$t('support-email-for-table--hello')}\n\n`
                                    + `${this.$t('support-email-for-table--predefined-introduction')}\n\n`
                                    + `${this.$t('support-email-for-table--remarks-introduction')}\n`
                                    + `${this.$t('support-email-for-table--remarks-separator')}\n\n\n\n`
                                    + `${this.$t('support-email-for-table--remarks-separator')}\n\n`
                                    + `${this.$t('support-email-for-table--displayed-annotation-introduction')}\n\n`
                                    + `${this.$t('support-email-for-table--preprocessing-object-introduction')}\n`
                                    + `${preprocessingResultContent}\n\n`
                                    + `${this.$t('support-email-for-table--annotation-object-introduction')}\n`
                                    + `${annotationContent}\n\n\n`
                                    + `${this.$t('support-email-for-table--conclusion')}\n`;

      const WELCOME_GET_A_DEMO = `${this.$t('welcome-email-for-demo--hello')}\n\n`
                                    + `${this.$t('welcome-email-for-demo--predefined-introduction')}\n\n`
                                    + `${this.$t('welcome-email-for-demo--remarks-introduction')}\n`
                                    + `${this.$t('welcome-email-for-demo--remarks-separator')}\n\n`
                                    + `${this.$t('welcome-email-for-demo--remarks-form-name-label')}\n`
                                    + `${this.$t('welcome-email-for-demo--remarks-form-surname-label')}\n`
                                    + `${this.$t('welcome-email-for-demo--remarks-form-email-label')}\n`
                                    + `${this.$t('welcome-email-for-demo--remarks-form-usecase-label')}\n\n`
                                    + `${this.$t('welcome-email-for-demo--remarks-separator')}\n\n`
                                    + `${this.$t('welcome-email-for-demo--conclusion')}\n`;

      const WELCOME_GET_API_ACCESS = `${this.$t('welcome-email-for-apî-access--hello')}\n\n`
                                    + `${this.$t('welcome-email-for-apî-access--predefined-introduction')}\n\n`
                                    + `${this.$t('welcome-email-for-apî-access--remarks-introduction')}\n`
                                    + `${this.$t('welcome-email-for-apî-access--remarks-separator')}\n\n`
                                    + `${this.$t('welcome-email-for-apî-access--remarks-form-name-label')}\n`
                                    + `${this.$t('welcome-email-for-apî-access--remarks-form-surname-label')}\n`
                                    + `${this.$t('welcome-email-for-apî-access--remarks-form-email-label')}\n`
                                    + `${this.$t('welcome-email-for-apî-access--remarks-form-usecase-label')}\n\n`
                                    + `${this.$t('welcome-email-for-apî-access--remarks-separator')}\n\n`
                                    + `${this.$t('welcome-email-for-apî-access--conclusion')}\n`;

      const WELCOME_GET_UI_ACCESS = `${this.$t('welcome-email-for-ui-access--hello')}\n\n`
                                    + `${this.$t('welcome-email-for-ui-access--predefined-introduction')}\n\n`
                                    + `${this.$t('welcome-email-for-ui-access--remarks-introduction')}\n`
                                    + `${this.$t('welcome-email-for-ui-access--remarks-separator')}\n\n`
                                    + `${this.$t('welcome-email-for-ui-access--remarks-form-name-label')}\n`
                                    + `${this.$t('welcome-email-for-ui-access--remarks-form-surname-label')}\n`
                                    + `${this.$t('welcome-email-for-ui-access--remarks-form-email-label')}\n`
                                    + `${this.$t('welcome-email-for-ui-access--remarks-form-usecase-label')}\n\n`
                                    + `${this.$t('welcome-email-for-ui-access--remarks-separator')}\n\n`
                                    + `${this.$t('welcome-email-for-ui-access--conclusion')}\n`;


      if (this.predefinedEmailContent === undefined) {
        return DEFAULT_EMAIL_CONTENT;
      } else if (this.predefinedEmailContent === 'GET_A_DEMO') {
        return WELCOME_GET_A_DEMO;
      } else if (this.predefinedEmailContent === 'GET_API_ACCESS') {
        return WELCOME_GET_API_ACCESS;
      } else if (this.predefinedEmailContent === 'GET_UI_ACCESS') {
        return WELCOME_GET_UI_ACCESS;
      }
      return DEFAULT_EMAIL_CONTENT;
    },
    linkedEmailContent: function() {
      return encodeURIComponent(this.emailContent);
    },
    linkedEmailsTo: function() {
      if (this.emailsTo && this.emailsTo[0]) {
        return this.emailsTo.join(';');
      }
      return 'dagobah.support@orange.com'
    },
    linkedSubject: function() {
      if (this.predefinedEmailContent === undefined) {
        return this.$t('support-email-for-table--subject');
      } else if (this.predefinedEmailContent === 'GET_A_DEMO') {
        return this.$t('welcome-email-for-demo--subject');
      } else if (this.predefinedEmailContent === 'GET_API_ACCESS') {
        return this.$t('welcome-email-for-apî-access--subject');
      } else if (this.predefinedEmailContent === 'GET_UI_ACCESS') {
        return this.$t('welcome-email-for-ui-access--subject');
      }
      return this.$t('support-email-for-table--subject');
    },
    hrefMailtoLink: function() {
      console.log("[MailtoLink] returned hrefMailtoLink = ", `mailto:${this.linkedEmailsTo}?subject=${this.linkedSubject}&body=${this.linkedEmailContent}`);
      return `mailto:${this.linkedEmailsTo}?subject=${this.linkedSubject}&body=${this.linkedEmailContent}`;
    }
  },
  methods: {
  }

};
</script>
<style scoped>
</style>